import './policy.scss';
import { Footer } from '../../components/Footer';

function AfterSalesPolicy() {
  return (
    <>
      <div
        className="policy-content"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/image/policy-bg.png)` }}
      >
        <div style={{ width: '100%', paddingTop: 12 }}>
          <span style={{ color: '#621ECE', paddingLeft: 12, fontSize: 16 }}>
            《桃高乐退换货售后政策》2026年4月1日生效版本
          </span>
        </div>
        <p
          style={{
            color: '#191430',
            whiteSpace: 'pre-line',
            paddingInline: 12,
            paddingBottom: 12,
            marginInline: 12,
            marginBottom: 12,
            fontSize: 13,
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderRadius: 12,
            border: '1px solid #ffffff',
          }}
        >
          <p style={{  color: '#621ECE', textAlign: 'center', fontSize: 16 }}>【特别提示】</p>
          {`退换货售后政策：
(1）修改地址：您可联系客服进行修改地址1次，不支持因错过修改地址而提出的取消订单和退款申请；
(2）模玩内手办商品类目，由于手办类物品为手工制作的定制类商品，因此可能存在轻微蹭色、溢色等涂装问题的瑕疵俗称官瑕，官瑕在手工定制类商品类目中为正常场景，将按据《消费者权益保障法》第二十五条第一款和《网络购买商品七日无理由退货暂行办法》第六条第一款执行，请您知悉并谨慎考虑后购买；
(3）如您收到的商品有质量问题，如存在损坏、少见或遗失，请您提供有效凭证，证明您在签收时商品即存在上述问题，模玩将提供退换货服务并承担来回运费。
不同类型商品的售后政策：
一、手办/FIGMA/粘土人/盒蛋类商品
由于属于手工定作类商品，将依据《消费者权益保护法》第二十五条第一款和《网络购买商品七日无理由退货暂行办法》第六条第一款执行。
【售后范国】
断件/缺件/配件错漏/蹭色/涂装不全/严重盒损等非人为损坏。
【非售后范国】
1.个人安装问题损坏；
2.个人原因退货退款；
3.商品本身工艺会存在差异，普遍存在的细小瑕疵、分模线痕迹、色差、水纹等;
4.商品外包装可能因生产、制作、打包、物流运输等原因造成轻微磕碰、凹陷、商品外盒雪梨纸/牛皮纸/保护纸破损、胶贴翘起/气泡等；
5.上述情况属于正常现象，模玩不受理此类原因的售后。未按提要求举证致使举证不充分的、未在本规则规定的期限内发起申请等情况也无法受理，请您谅解。
【举证要求】
1.非模玩第二次包装商品：内部透明包装/吸塑式包装/透明包装袋的照片/视频或其他举证；
2.模玩二次包装商品：证明问题的照片/视频或其他举证。
【售后处理方式】
1.属于质量问题的，将购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2. 部分商品属于品牌方提供售后，请按照模玩提供的联系方式进行售后申请，品牌方可提供售后范围为（部件换新/整件换新/修复)；
3.售后处理方式为部件换新/整件换新/修复，仅限模玩/品牌方无法提供上述售后服务时，由模玩为用户提供退货退款方案。
二、3C类商品
支持七天无理由退换货
【售后范围】
1.商品质量问题；
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范围】
1.手机、数码含授权或激活信息的，包括但不限于序列号、激活码、CDKEY等，一旦产生授权或激活程序，将依据《消费者权益保护法》第二十五条第三款和《网络购买商品七日无理由退货暂行办法》第六条第三款执行
2.若商品因使用产生商品清洁度、磨损度受损严重如加湿器使用后产生水渍问题等造成无法二次销售的;
3.其他因商品性质特殊且提前在页面告知您的。
【举证要求】
1.证明问题的服片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.对于存储类商品，请务必在返修前将里面的数据自行导出，否则若有数据遗失、损坏等模玩概不承担相应的贵任；
2.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，并寄回办理退换货手续；
3.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被委托的第三方快递运输损毁，影响退货。
三、家居用品
支持七天无理由退换货
【售后范围】
1.商品质量问题；
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范国】
商品被洗过、穿过、认为破坏或标牌拆除、影响二次销售的。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被委托的第三方快递运输损毀，影响退货。
四、服饰类/箱包配饰/文具文体/毛绒玩具
支持七天无理由退换货
【售后范围】
1.商品质量问题：
2.物流破损问题；
3.描述不符问题；
4.支持7天无理由退换货的商品。
【非售后范围】
1.出于安全与卫生考虑，贴身用品如内衣裤、袜子、泳衣类商品，将依据《网络购买商品七日无理由退货暂行办法》第七条第一款执行。经权威部门检测商品存在质量问题的除外；
2.因个人原因造成的商品损坏(如自行修改尺寸，洗涤，刺绣，长时间穿着等）影响二次销售的；
3.商品及配件有由使用造成的磨损、损坏和痕迹的。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.属于质量问题的，特说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续；
2.如商品符合7天无理由退换货条件，需要在寄出前妥善包装，以免被受托的第三方快递运输损毁，影响退货。
五、出版物
依据《消费者权益保护法》第二十五条第三款和《网络购买商品七日无理由退货暂行办法》第六条第三款、第四款执行。
【售后范围】
开封前商品包装破损、异常/腰封缺少/破损/排版有误/装订问题/缺少页数/错别字较多/本体破损/撞角严重。
【非售后范国】
1.包装含防份码的商品防伪码刮开后；
2.有序列号的商品，刮开使用后无质量问题的；
3.若商品存在因使用造成的商品受损，污染等情况的；
4.任何因非正常使用及保管导致商品出现质量问题的；
5.免费赠品；
6.定制期刊类商品、海外订购类、图书商品等。
【举证要求】
1.证明问题的照片/视频或其他举证；
2.物流破损需提供商品实物破损照片。
【售后处理方式】
1.退货时赠品需一并返回模玩，如赠品缺失，则商品无法全额退款（换货无需返回）；
2.属于质量问题的，将说明书、发票、保修卡、购物凭证、包装、问题商品等所有物品，一并寄回办理退换货手续。

桃高乐应用内的一切商业活动与Apple inc无关。如有任何玩法疑问的，可以发送电子邮件到service@taogao88.com邮箱或者在线客服咨询。`}
        </p>
      </div>
      <Footer />
    </>
  );
}

export default AfterSalesPolicy;
